import { render, staticRenderFns } from "./ComputersApplications.vue?vue&type=template&id=c10cf0cc&scoped=true&"
import script from "./ComputersApplications.vue?vue&type=script&lang=js&"
export * from "./ComputersApplications.vue?vue&type=script&lang=js&"
import style0 from "./ComputersApplications.vue?vue&type=style&index=0&id=c10cf0cc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10cf0cc",
  null
  
)

export default component.exports